import type { EvaluationCheckpointResponse } from "@/api";
import { Utility } from "./utility";

export interface EvaluationCheckpoint extends EvaluationCheckpointResponse {}

export class EvaluationCheckpoint extends Utility<EvaluationCheckpoint> {
  constructor(init?: Partial<EvaluationCheckpointResponse>) {
    super();
    Object.assign(this, init);
  }

  get is_additional_question(): boolean {
    return (
      this.category === "additional_questions" ||
      this.category.startsWith("additional_question")
    );
  }
}
